import React, { useEffect, useState } from 'react'
import IAdNews from '../../interfaces/AdNews';
import IPageProps from '../../interfaces/page'
import { getAdNews, getAdNewsByKeyword } from '../../services/AdNewsService';
import FooterPage from '../footer';
import TopNavPage1 from '../topNav1';
import TopNavPage2 from '../topNav2';

const AllNews: React.FunctionComponent<IPageProps> = props => {
  const [adNews, setAdNews] = useState<IAdNews[]>([])
  const [refresh, setRefresh] = useState(false);
  const [entPressed, setEntPressed] = useState(false);
  const [inpKeyword, setInpKeyword] = useState("")

  const sortNews = (newsList: IAdNews[]) => {
    return newsList.sort((a, b) => {
      const aIsTop = String(a.TopNews) === '1';
      const bIsTop = String(b.TopNews) === '1';

      if (aIsTop && !bIsTop) return -1;
      if (!aIsTop && bIsTop) return 1;

      if (aIsTop && bIsTop) {
        // Both are Top News -> Sort by LastEditDate desc
        // Fallback to SendDate if LastEditDate is missing
        const dateA = a.LastEditDate ? new Date(a.LastEditDate).getTime() : new Date(a.SendDate).getTime();
        const dateB = b.LastEditDate ? new Date(b.LastEditDate).getTime() : new Date(b.SendDate).getTime();
        return dateB - dateA;
      }

      // Both are NOT Top News -> Sort by SendDate desc
      const dateA = new Date(a.SendDate).getTime();
      const dateB = new Date(b.SendDate).getTime();
      return dateB - dateA;
    });
  }

  const inpAdNews = (e: React.FormEvent<HTMLInputElement>) => {
    setInpKeyword(e.currentTarget.value.replaceAll("/", "%2F"));
  }

  const filterAdNews = () => {
    if (inpKeyword === "") {
      changeAllNews('*');
    }
    else {
      changeAllNews(inpKeyword.trim());
    }
  }

  const changeAllNews = (key: string) => {
    getAdNewsByKeyword(key).then(data => {
      setAdNews(sortNews(data));
    });

  }

  const handleKeyDown = (e: React.KeyboardEvent<HTMLElement>) => {
    if (e.key === "Enter") setEntPressed(true);

  }

  const handleSearch = () => {
    setEntPressed(true);
  }

  useEffect(() => {
    if (entPressed) {
      if (inpKeyword === "") {
        getAdNews('', 0).then(data => {
          setAdNews(sortNews(data));
        });
      }
      else {
        getAdNews(inpKeyword.trim(), 0).then(data => {
          setAdNews(sortNews(data));
        });
      }
      setEntPressed(false);
    }
  }, [entPressed])

  useEffect(() => {
    getAdNews('', 0).then(data => {
      const sortedData = sortNews(data);
      setAdNews(sortedData);
      sortedData.map((item, i) => {
        let innerBody = document.getElementById('context-' + i.toString());
        if (innerBody !== null) innerBody.innerHTML = item.Context;
      })
    })

  }, [])

  useEffect(() => {
    if (adNews.length > 0) {
      adNews.map((item, i) => {
        let innerBody = document.getElementById('context-' + i.toString());
        if (innerBody !== null) innerBody.innerHTML = item.Context;
      })
    }
  }, [adNews])


  return (
    <>
      <TopNavPage1 />
      <div className="section pt-3 pt-lg-5">
        <div className="container">
          <div className="d-flex flex-column flex-md-row justify-content-between align-items-center">
            <h5 className="title mb-3">最新消息<small className="ms-2">NEWS</small></h5>
            <div className="form-group flex-grow-1 float-end" style={{ maxWidth: '410px' }}>
              <div className="input-group">
                <span className="input-group-text"><span className="material-icons-outlined text-muted" onClick={() => handleSearch()}>search</span></span>
                <input className="form-control ps-3" placeholder="搜尋消息" type="text" onChange={inpAdNews} onKeyDown={handleKeyDown} />
              </div>
            </div>
          </div>
          <div className="card p-2">
            <div className="table-responsive">
              <table className="table table-striped table-hover align-items-center mb-0">
                <thead className="">
                  <tr style={{ color: '#5c71a2' }}>
                    <th className="text-sm font-weight-bolder text-nowrap p-2 text-center">置頂</th>
                    <th className="text-sm font-weight-bolder text-nowrap p-2">日期</th>
                    <th className="text-sm font-weight-bolder text-nowrap px-2 px-md-3">內容</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    adNews.map((data, i) => {
                      if (!data.Context) return null;
                      return <tr>
                        <td className="text-center py-3">
                          {(String(data.TopNews) === '1') ? <span style={{ color: 'orange', fontWeight: 'bold' }}>★</span> : <i className="fas fa-thumbtack text-gray transform-rotate pointer"></i>}
                        </td>
                        <td className="text-sm">{data.SendDate}</td>
                        <td className="text-dark text-wrap py-3" id={'context-' + i.toString()}></td>
                      </tr>
                    })
                  }
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <FooterPage />
    </>
  );
}
export default AllNews;
